<template>
  <div class="bg-white" style="padding: 10px 7px;">
    <pageTable :custCode="custCode" />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  components: {
    PageTable,
  },
  props: {
    custCode: { type: String, default: '' },
  },
}
</script>
<style lang="scss" scoped>
.bg-white {
  background-color: white;
}
</style>
